import { getCookie } from '../Services/CookiesService';

export const getText = (textKey) => {
  const defaultLanguage = 'en';
  const selectedLanguage = getCookie(window.__CONFIG__.LANGUAGE_COOKIE_NAME) || defaultLanguage;
  if (!textKey) return null;

  const language = ['en', 'es', 'pt'].includes(selectedLanguage.toLowerCase())
    ? selectedLanguage.toLowerCase()
    : defaultLanguage;
  const translation = window.__CONFIG__.TRANSLATIONS[textKey];

  return translation?.[`text_${language}`] || translation?.[`text_${defaultLanguage}`] || textKey;
};

export default {
  getText,
};
